const mocks = {
  getters: {
    getDomicilio: () => ({
      codPais: "080",
      codProv: "01",
      localid: "01",
      desDomi: "01",
      codPost: "1900",
      inusual: false,
      dudas: ["duda1", "duda2"]
    }),
    getCondicionCliente: () => ({
      retorno: "01"
    }),
    getDomicilios: () => [
      {
        coorX: "-58.392801",
        coorY: "-34.593310"
      }
    ],
    getCircuito: () => "abc123",
    getSucursal: () => "23",
    getBanelco: () => false,
    getLaborales: () => ({
      sitLab: "01",
      ocupa: "01",
      activid: "01",
      ingDec: "31999"
    }),
    getDatosNormativos: () => ({
      sujObl: "01",
      pep: "01",
      fatca: "01"
    }),
    getNombreProducto: () => "Tarjeta BBVA Vos",
    getAceptoContrato: () => ({
      firmaContrato: true
    }),
    getConsultaContrato: () => ({
      contrato: {
        urlPDFBase64: "url"
      }
    }),
    getContratosTJVOS: () => ({
      contratos: [{ urlPDFBase64: "url" }, { urlPDFBase64: "url" }]
    })
  },
  state: {
    ga4: {
      eventParams: {
        level3: "solicitud de tarjeta",
        level4: "4 datos laborales"
      }
    }
  }
};

export default mocks;
